module.exports = __webpack_public_path__ + "static/media/ic-close-24.bc57da5d.svg";